import * as React from "react";
const SvgPdu = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.5 5.5v1.479h1.97v9.625H7.826l1.67-1.682 1.671-1.68-.521-.525-.522-.524-2.56 2.577L5 17.348l2.563 2.576 2.56 2.576.522-.523.521-.524-1.672-1.682-1.67-1.68h15.127V5.5Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } }),
    React.createElement("path", { d: "m14.4 1-.468.523-.467.524 1.5 1.682 1.5 1.68H.87V18H4.46v-1.479h-2.26V6.896h14.266l-1.5 1.682-1.5 1.68.467.525.468.524 2.3-2.577L19 6.152l-2.3-2.576Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgPdu;
